import {Pipe, PipeTransform} from '@angular/core';
import {AbstractControl, FormGroup} from "@angular/forms";
import {TranslocoService} from "@jsverse/transloco";

@Pipe({
  name: 'fileValidationTooltipText',
  pure: false
})
export class FileValidationTooltipTextPipe implements PipeTransform {

    constructor(private translocoService: TranslocoService) {
    }

  transform(value: AbstractControl | FormGroup): string {
    if(value.invalid){
        const errors = (<FormGroup>value)?.controls.file.errors;
        if(errors){
           const detailedMessage = Object.values(errors).reduce((prev, currentValue)=> `${prev} ${currentValue},`,'');
            return this.translocoService.translate('Detailed validation error file tooltip (upload files validation tooltip) - This file does not meet the requirements. The following conditions have not been meet', {message:detailedMessage});
        }else if (value.errors){
            const detailedMessage = Object.values(value.errors).reduce((prev, currentValue)=> `${prev} ${currentValue},`,'');
            return `${detailedMessage}`;
        }
        return this.translocoService.translate('General validation error file tooltip (upload files validation tooltip) - This file does not meet the requirements');
    }

      return '';
  }

}
